export default __webpack_public_path__ + "static/media/Element-4.606ca2b3.png";